__turbopack_context__.v({
  "className": "geist_mono_12c8e554-module__YeJpdq__className",
});
